import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";

interface WindowSize {
  width: number | undefined;
  height: number | undefined;
}

const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [size] = useDebounce(windowSize, 200, { leading: true });
  return size;
};

export function useWindowSizeString(): string {
  const ws = useWindowSize();
  return `${ws.width}_${ws.height}`;
}

export default useWindowSize;
